import { render, staticRenderFns } from "./paginationSelect.vue?vue&type=template&id=64c6dde0&scoped=true&"
import script from "./paginationSelect.vue?vue&type=script&lang=js&"
export * from "./paginationSelect.vue?vue&type=script&lang=js&"
import style0 from "./paginationSelect.vue?vue&type=style&index=0&id=64c6dde0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6dde0",
  null
  
)

export default component.exports